module.exports = __webpack_public_path__ + "media/auto-analy_mobile.9846cbe9.mp4";